var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5884 14.9105C3.28158 16.19 3.92648 16.3699 5.34218 18.2994C7.65713 21.4571 7.31541 22.7623 8.00399 23.3636C8.69 23.9648 11.8374 24.4504 13.9828 21.7038C16.1282 18.9572 19.476 11.3751 23.7668 6.82743C28.0575 2.27973 30.0616 0.964243 31.3488 0.275666C32.636 -0.410342 28.556 -0.263891 20.5346 6.11316C14.9566 10.5478 11.0075 16.6705 11.0075 16.6705C11.0075 16.6705 9.89244 13.3227 7.40277 11.0925C4.9131 8.85976 -1.22243 12.7882 1.5884 14.9131V14.9105Z",
    fill: "#2FA124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.24a5152217bfe69d2e53595ec11d7501.svg";
export { ForwardRef as ReactComponent };